import clsx from "clsx";
import { HTMLAttributes } from "react";

type ProgressBarProps = HTMLAttributes<HTMLDivElement> & {
  percentage: number;
  text?: string;
  color?: string;
};

const ProgressBar = ({
  percentage,
  text,
  color = "bg-primary-blue-400",
  className,
}: ProgressBarProps) => {
  return (
    <div className="relative h-full w-full">
      <div
        className={clsx(
          "h-full transition-transform",
          className,
          color,
        )}
        style={{ width: `calc(${percentage}%)` }}
      />
      {text && (
        <div className="absolute inset-0 flex items-center justify-center text-sm font-medium">
          {text}
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
